// Utils
import PRConfig from "components/Stacker/config/ProductConfiguratorConfig"
import isMobile from "components/Stacker/utils/device-check"

export function getS7ConfigUrl(configTypeValue, theme, metal) {
  const isMobileScreen = isMobile()

  let imgUrl
  if (
    isMobileScreen &&
    configTypeValue === PRConfig.PENDANT_PRODUCTS.PRODUCT_TYPE
  ) {
    imgUrl = `https://img.davidyurman.com/is/image/DavidYurmanNew/mobile-${configTypeValue}-${theme}-img-${metal}-`
  } else {
    imgUrl =
      configTypeValue === PRConfig.PINKY_PRODUCTS.PRODUCT_TYPE
        ? `https://img.davidyurman.com/is/image/DavidYurmanNew/${theme}-img-${metal}-`
        : `https://img.davidyurman.com/is/image/DavidYurmanNew/${configTypeValue}-${theme}-img-${metal}-desktop-`
  }

  return imgUrl
}
